import { MicrosoftTeamsModels } from '@models/microsoft-teams.model';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { MicrosoftTeamsActions } from './microsoft-teams.action-types';

export declare interface MicrosoftTeamsState extends EntityState<MicrosoftTeamsModels.ChannelModel> {
  selectedChannel: MicrosoftTeamsModels.ChannelModel;
  notEmpty: boolean;
  deletingChannelIds: string[];
  isInitialLoaded: boolean;
  isCreating: boolean;
  isTesting: boolean;
  testPassed: boolean;
  testFinished: boolean;
  isDeleting: boolean;
}

export const adapter: EntityAdapter<MicrosoftTeamsModels.ChannelModel> =
  createEntityAdapter<MicrosoftTeamsModels.ChannelModel>({
    selectId: (channel: MicrosoftTeamsModels.ChannelModel) => channel._id,
  });

const initialState: MicrosoftTeamsState = adapter.getInitialState({
  selectedChannel: null,
  deletingChannelIds: [],
  notEmpty: null,
  isInitialLoaded: false,
  isCreating: false,
  isTesting: false,
  testPassed: false,
  testFinished: false,
  isDeleting: false,
});

const { selectAll } = adapter.getSelectors();

export const microsoftTeamsReducer = createReducer(
  initialState,
  on(MicrosoftTeamsActions.resetToInitialState, (state) => {
    return {
      ...initialState,
    };
  }),
  on(MicrosoftTeamsActions.resetAllTestState, (state) => {
    return {
      ...state,
      isTesting: false,
      testPassed: false,
      testFinished: false,
    };
  }),
  on(MicrosoftTeamsActions.getOrganizationMicrosoftTeamsChannelsSuccess, (state, { channels }) => {
    return adapter.setAll(channels, {
      ...state,
      isInitialLoaded: true,
      notEmpty: !state.isInitialLoaded ? !!channels.length : state.notEmpty,
    });
  }),
  on(MicrosoftTeamsActions.getOrganizationMicrosoftTeamsChannelsFail, (state) => {
    return {
      ...state,
      isInitialLoaded: true,
    };
  }),
  on(MicrosoftTeamsActions.setIsCreatingLoader, (state, { isCreating }) => {
    return {
      ...state,
      isCreating,
    };
  }),
  on(MicrosoftTeamsActions.setIsDeletingLoader, (state, { isDeleting }) => {
    return {
      ...state,
      isDeleting,
    };
  }),
  on(MicrosoftTeamsActions.startDeleteChannel, (state, { id }) => {
    return {
      ...state,
      deletingChannelIds: [...state.deletingChannelIds, id],
    };
  }),
  on(MicrosoftTeamsActions.sendDeleteChannelRequestSuccess, (state, { id }) => {
    const deletingIndex = state.deletingChannelIds.findIndex((_id) => _id === id);
    let newDeletingArray = [...state.deletingChannelIds];
    newDeletingArray.splice(deletingIndex, 1);
    return adapter.removeOne(id, {
      ...state,
      deletingChannelIds: newDeletingArray,
      notEmpty: selectAll(state).length > 1,
    });
  }),
  on(MicrosoftTeamsActions.getChannelByIdSuccess, (state, { channel }) => {
    return {
      ...state,
      selectedChannel: channel,
    };
  }),
  on(MicrosoftTeamsActions.addNewChannelSuccess, (state, { channel }) => {
    return adapter.addOne(channel, { ...state, notEmpty: true });
  }),
  on(MicrosoftTeamsActions.sendDeleteChannelRequestFail, (state, { id }) => {
    const deletingIndex = state.deletingChannelIds.findIndex((_id) => _id === id);
    let newDeletingArray = [...state.deletingChannelIds];
    newDeletingArray.splice(deletingIndex, 1);
    return {
      ...state,
      deletingChannelIds: newDeletingArray,
    };
  }),
  on(MicrosoftTeamsActions.startTest, (state) => {
    return {
      ...state,
      isTesting: true,
    };
  }),
  on(MicrosoftTeamsActions.startTestExist, (state) => {
    return {
      ...state,
      isTesting: true,
    };
  }),
  on(MicrosoftTeamsActions.startTestSuccess, (state) => {
    return {
      ...state,
      isTesting: false,
      testPassed: true,
      testFinished: true,
    };
  }),
  on(MicrosoftTeamsActions.startTestFail, (state) => {
    return {
      ...state,
      isTesting: false,
      testPassed: false,
      testFinished: true,
    };
  }),
  on(MicrosoftTeamsActions.sendDeleteAllChannelRequestSuccess, (state) => {
    return adapter.removeAll({
      ...state,
      notEmpty: false,
    });
  }),
);
